import * as actions from '../actions/actionTypes';

export const initialState = {
  workflowDefinitions: [],
  workflowDefinitionRequest: {
    fetchRequest: {
      error: {},
      loading: false,
    },
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.FETCH_WORKFLOW_DEFINITIONS_SUCCESS:
      return {
        ...state,
        workflowDefinitions: action.workflowDefinitions,
      };
    case actions.FETCH_WORKFLOW_DEFINITIONS_FAILURE: {
      const request = {
        fetchRequest: {
          ...state.workflowDefinitionRequest.fetchRequest,
          error: action.error,
        },
      };

      return {
        ...state,
        workflowDefinitionRequest: request,
      };
    }
    case actions.SET_WORKFLOW_DEFINITIONS_FETCH_REQUEST_LOADING: {
      const request = {
        fetchRequest: {
          ...state.workflowDefinitionRequest.fetchRequest,
          loading: action.loading,
        },
      };

      return {
        ...state,
        workflowDefinitionRequest: request,
      };
    }
    default:
      return state;
  }
}
